<template>
  <v-dialog v-model="dialogIsVisible" :width="width">
    <v-card flat class="pt-4">
      <v-icon class="close" @click.prevent="dialogIsVisible = false">$sl-close</v-icon>
      <h2>
        {{ isMachineProfession ? $t('labels.machine-profession.title', { company: companyName, machines: acquiredMachines }) : $t("application.sameProfession.title", { professionName, companyName }) }}
      </h2>
      
      <p v-if="isMachineProfession">{{ $t('labels.machine-profession.text') }}</p>

      <template v-else>
        <p class="pt-2" v-if="isUnderGU">{{ $t("application.sameProfession.text-2") }} </p>
        <p class="pt-2" v-else>{{ $t("application.sameProfession.text") }} </p>
      </template>
    </v-card>

    <main>
      <slot name="content" />
    </main>

    <div class="d-flex flex-wrap">
      <slot name="actions" />
    </div>
  </v-dialog>
</template>

<script>
import ActionButton from "@/components/Common/ActionButton";
import { mapGetters } from 'vuex'
import get from "lodash/get";
import orderBy from "lodash/orderBy";

export default {
  name: 'ApplicationTransferDialog',

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    profession: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: 400
    },
    isMachineProfession: {
      type: Boolean,
      default: false
    },
  },

  components: {
    ActionButton
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser']),

    isUnderGU() {
      const education = this.currentUser.educations?.find(o => o.professionId === get(this, 'profession.id', null))
      if ( education == null ) return false

      const { type, qualificationTime } = education
      return type === 'DistanceEducation' && !qualificationTime
    },

    companyName() {
      return orderBy(get(this, 'currentUser.apprenticeships', []), ['id'], ['desc'])
        .find(o => o.professionId === get(this, 'profession.id', null))?.company?.name
    },

    professionName() {
      return get(this, 'profession.name', '')
    },

    dialogIsVisible: {
      get() {
        return this.isVisible
      },
      set(value) {
        this.$emit('close', value)
      }
    },

    acquiredMachines() {
      return get(this, 'currentUser.educations', [])
        .find(({ professionId }) => get(this, 'profession.id', null) === professionId)
        ?.educationProfessionOrientations
        ?.map(({ professionMachineOrientation }) => professionMachineOrientation.machine.name).join(', ')
    }
  }
}
</script>